import React, { useCallback } from 'react'
import Image from 'components/Common/Image'
import ListItem from 'components/Luxkit/List/ListItem'
import SquareCheckboxInput from 'components/Luxkit/Checkbox/SquareCheckboxInput'

interface Props {
  searchItem: App.SearchItem;
  imageId?: string;
  isSelected: boolean;
  isSearching: boolean;
  onChange: (value: App.SearchItem | null, isRemoving?: boolean) => void;
}

function CruiseLocationItem({ searchItem, imageId, isSelected, isSearching, onChange }: Props) {
  const onLocationChange = useCallback(() => {
    onChange(searchItem, isSelected)
  }, [onChange, searchItem, isSelected])

  return <ListItem
    onClick={onLocationChange}
    startIcon={!isSearching && <Image
      id={imageId ?? 'f2uxhz5mnuyqnyln891b'}
      alt={searchItem.format.mainText}
      width={48}
      height={48}
    />}
    title={searchItem.format.mainText}
    subtitle={searchItem.format.secondaryText}
    endIcon={
      <SquareCheckboxInput
        variant="large"
        checked={isSelected}
      ></SquareCheckboxInput>
    }
  />
}

export default CruiseLocationItem
